import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input, output, TemplateRef } from '@angular/core';
import { UiDarkmodeSwitchComponent } from '@big-direkt/ui/darkmode-switch';
import { UiLinkComponent } from '@big-direkt/ui/link';
import { FeatureFlagsService } from '@big-direkt/utils/environment';
import {
    type BigIcon,
    IconBigLightDarkmode,
    IconBigLightKontakt,
    IconBigLightLeichteSprache,
    IconBigLightTelefon24H,
    IconBigMediumChat,
    IconBigMediumDarkmode,
    IconBigMediumLeichteSprache,
    type IconMap,
    IconMapToIconPipe,
} from '@big-direkt/utils/icons';
import { type MenuItemModel, MenuModel } from '@big-direkt/utils/shared';

@Component({
    selector: 'big-nav-quicknav',
    templateUrl: './nav-quicknav.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [IconMapToIconPipe, UiLinkComponent, UiDarkmodeSwitchComponent, NgTemplateOutlet],
})
export class NavQuicknavComponent {
    private readonly featureFlagsService = inject(FeatureFlagsService);
    public readonly isDarkmodeEnabled = this.featureFlagsService.isFeatureEnabled('dark-mode');
    public readonly itemClicked = output();

    public readonly iconMap: IconMap = {
        /* eslint-disable @typescript-eslint/naming-convention */
        'big-light-darkmode': IconBigLightDarkmode, // TODO: Remove this after the icon was changed in CMS
        'big-medium-darkmode': IconBigMediumDarkmode,
        'big-light-kontakt': IconBigLightKontakt, // TODO: Remove this after the icon was changed in CMS
        'big-medium-chat': IconBigMediumChat,
        'big-light-leichte-sprache': IconBigLightLeichteSprache, // TODO: Remove this after the icon was changed in CMS
        'big-medium-leichte-sprache': IconBigMediumLeichteSprache,
        'big-light-telefon-24-h': IconBigLightTelefon24H,
        /* eslint-enable @typescript-eslint/naming-convention */
    };

    public readonly wrapperClass = input('');
    public readonly menu = input.required<MenuModel | undefined>();
    public readonly itemTemplate = input.required<TemplateRef<{ item: MenuItemModel; icon: BigIcon }>>();
}
